import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner() {
  return (
    <div className="aro-spinner-wrap">
      <span className="aro-spinner" />
    </div>
  );
}
